import React from 'react';
import { StatCard } from './StatCard';
import { DuoClockIcon } from '../../theme/Icons';
import { IPeriodData } from '../model/IPeriodData';
import { PctChangeIndicator } from './PctChangeIndicator';
import { round } from '../../utils/format';

export const CareHoursStatCard: React.FC<{selectedPeriod: IPeriodData, priorPeriod: IPeriodData}> = ({ selectedPeriod, priorPeriod }) => {

    const getAverageHours = (period: IPeriodData) => {
        const checkinsWithHours = period.care.filter(c => c.totalCareHours !== undefined);
        const total = checkinsWithHours.reduce((a, c) => a + c.totalCareHours!, 0);
        return checkinsWithHours.length ? total / checkinsWithHours.length : undefined;
    };

    const hours = getAverageHours(selectedPeriod);
    const priorHours = getAverageHours(priorPeriod);

    return (
        <StatCard
            data-id="care-hours-card"
            Icon={DuoClockIcon}
            iconColor="theme-red-orange"
            description="care hours per day"
            value={hours === undefined ? '—' : String(round(hours, 1))}
            changeIndicator={
                <PctChangeIndicator newValue={hours || 0} oldValue={priorHours || 0} />
            }
        />
    );
};
